module.exports = __webpack_public_path__ + "static/haitian-school-kids.faa5e105.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/public/images/haitian-school-kids.jpg
// module id = 146
// module chunks = 0